import {
	Add01Icon,
	Building06Icon,
	UserDollarIcon,
	UserIcon,
} from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function NewClientButton() {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				render={
					<Button>
						<HugeiconsIcon
							icon={Add01Icon}
							strokeWidth={2}
							data-icon="inline-start"
						/>
						Nový klient
					</Button>
				}
			/>
			<DropdownMenuContent align="end">
				<DropdownMenuItem render={<Link href="/clients/new_individual" />}>
					<HugeiconsIcon icon={UserIcon} strokeWidth={2} />
					Fyzická osoba
				</DropdownMenuItem>
				<DropdownMenuItem
					render={<Link href="/clients/new_individual_entrepreneur" />}
				>
					<HugeiconsIcon icon={UserDollarIcon} strokeWidth={2} />
					Fyzická osoba (OSVČ)
				</DropdownMenuItem>
				<DropdownMenuItem render={<Link href="/clients/new_business" />}>
					<HugeiconsIcon icon={Building06Icon} strokeWidth={2} />
					Právnická osoba
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
